














import { Component, Prop, Vue } from 'vue-property-decorator'
import { Project } from '../types'
import ProjectCard from '@/components/ProjectCard.vue'

@Component({ components: { ProjectCard } })
export default class extends Vue {
  activeList: number[] = []
  projectColor = 'primary' // 125, 155, 220
  mentorshipColor = 'accent' // 125, 204, 220
  speakingColor = 'secondary' // 220, 188, 125

  toggleCard(index: number) {
    const i = this.activeList.indexOf(index)
    if (i >= 0) delete this.activeList[i]
    else this.activeList.push(i)
  }

  isActive(index: number) {
    return this.activeList.includes(index)
  }

  get timeline() {
    const projects: Project[] = this.$store.state.projects
      .filter((p: Project) => p.category === 'project' || p.category === 'job')
      .map((p: Project) => {
        return { category: 'project', color: this.projectColor, ...p }
      })
    const mentorship: Project[] = this.$store.state.mentorship.map((p: Project) => {
      return {
        category: 'mentorship',
        tags: [{ name: 'Mentorship' }],
        small: true,
        color: this.mentorshipColor,
        ...p
      }
    })

    const speaking: Project[] = this.$store.state.speaking.map((p: Project) => {
      return { category: 'speaking', tags: [{ name: 'Speaking' }], small: true, color: this.speakingColor, ...p }
    })

    const items: Project[] = [...projects, ...mentorship, ...speaking]

    return items.sort((p1, p2) => p2.date.getTime() - p1.date.getTime())
  }
}
